import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-4",
  title,
  items,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.AdditionalHighlights)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} className={classes.bg_1} />
      <Container fluid="md">
        <Row>
          <Col xs={12} lg={4}>
            <EditableText path="title" tag="h2" className="mb-3">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
          </Col>
          <Col xs={12} lg={8}>
            <Row>
              {items.map(({ icon, title, description }, idx) => (
                <Col key={idx} xs={12} md={6}>
                  <div className={cn(classes.card, "border-top pt-4")}>
                    <h5 className="mb-3">
                      <i />
                      <EditableText path={`item_${idx}_title`} tag="span">
                        <span dangerouslySetInnerHTML={{ __html: title }} />
                      </EditableText>
                    </h5>
                    <EditableHtml path={`item_${idx}_description`}>
                      <div dangerouslySetInnerHTML={{ __html: description }} />
                    </EditableHtml>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
